import { useCallback, useState, useEffect, useContext, useMemo, ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { BiArea, BiImages } from 'react-icons/bi';
import { useNavigate, useParams } from 'react-router-dom';
import { Button } from '../../components/Button';
import { Header, ScrollProps } from '../../components/Header';
import { ShowAllPhotos } from '../../components/ShowAllPhotos';
import { IBuildindCorretor, IPropertyDetailsCorrector, IPropsCorretor } from '../../types';
import { Container, NotFoundContent } from './styles';
import { Footer } from '../../components/Footer';
import { FaBath, FaCar, FaChartArea, FaRegCalendarAlt, FaUserCircle } from 'react-icons/fa';
import { LoadSpinner2 } from '../../components/LoadSpinner2';
import { ShowPhotoLargue } from '../../components/ShowPhotoLarge';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { maskPhone } from '../../utils/mask';
import { toast } from 'react-toastify';
import validator from 'validator';
import {
  MdLocalPhone,
  MdLocationPin,
  MdMeetingRoom,
  MdOutlineBathroom,
  MdWhatsapp,
} from 'react-icons/md';
import { FiDownload, FiFolder, FiLink, FiMinusCircle, FiPlusCircle, FiShare2, FiStar } from 'react-icons/fi';
import { useAuth } from '../../context/auth';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { GoToTop } from '../../GoToTop';
import { Carousel as Carosel2 } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ReactPlayer from 'react-player';
import { IoChevronBackOutline, IoDocumentText } from 'react-icons/io5';
import { SadAnimation } from '../../components/SadAnimation';
import { ShareListContext } from '../../context/shareList';
import Mainframe from '../../components/MainFrame';
import './styles.css';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import ModalAddToFolder from '../../components/ModalAddToFolder';
import { Circle, MapContainer, Marker, TileLayer } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import mapPin from '../../assets/mapPin.svg';
import L from 'leaflet';
import {
  PropertyDetailLayout,
  BodyText,
  CircleBtn,
  DownloadBtn,
  GalleryDesktopOnly,
  GalleryMain,
  GalleryMobile,
  GalleryThumb,
  GalleryThumbs,
  LocationLine,
  LocationLines,
  MetaRow,
  MorePhotosBtn,
  OverviewGrid,
  OverviewIcon,
  OverviewItem,
  OverviewText,
  PdfLinkBtn,
  PriceBlock,
  SaibaMaisCard,
  SaibaMaisItem,
  SaibaMaisItems,
  SaibaMaisTab,
  SaibaMaisTabs,
  ScheduleInner,
  ShareCircleBtn,
  ShareCircleLink,
} from '../../components/PropertyDetailLayout';
import { SectionRails } from '../../components/SectionRails';
import { PropertyCardCarousel } from '../../components/PropertyCardCarousel';

const PLACEHOLDER_IMG = '/images/placeholder-image-nogueira.png';

const MySwal = withReactContent(Swal);

function buildSaibaMaisFromCategories(
  categorias?: IPropertyDetailsCorrector['categorias'],
): Record<string, string[]> {
  if (!categorias?.length) return {};

  const result: Record<string, string[]> = {};
  categorias.forEach((cat) => {
    if (!cat?.titulo) return;
    const tags =
      cat.tags
        ?.map((tag) => tag.titulo)
        .filter((titulo) => Boolean(titulo?.trim())) || [];
    if (tags.length) {
      result[cat.titulo] = tags;
    }
  });

  return result;
}

function formatArea(value?: string) {
  if (!value) return '';
  return value.includes('M²') || value.includes('m²') ? value : `${value} M²`;
}

function photoUrl(url?: string) {
  if (!url || url === 'https://www.nogueiracorretores.com.br/') {
    return PLACEHOLDER_IMG;
  }
  return url;
}

export function PropertyDetailsShare() {
  const navigate = useNavigate();
  const { id, id_corretor } = useParams();
  const { addImovel } = useContext(ShareListContext);
  const { user, api } = useAuth();

  const [loading, setLoading] = useState(true);
  const [loadingRelation, setLoadingRelation] = useState(true);
  const [loadingPerson, setLoadingPerson] = useState(true);
  const [loadingVisita, setLoadingVisita] = useState(false);
  const [search, setSearch] = useState('');

  const [isValidId, setIsValidId] = useState(false);

  const [obs, setObs] = useState('');
  const [nomeCliente, setNomeCliente] = useState('');
  const [emailCliente, setEmailCliente] = useState('');
  const [contatoCliente1, setContatoCliente1] = useState('');
  const [horaReserva, setHoraReserva] = useState('');

  const [dateReserve, setDateReserve] = useState<any>();
  const [dateFormat, setDateFormat] = useState<any>();

  const [viewAllPhotos, setViewAllPhotos] = useState(false);
  const [viewPhotoFull, setViewPhotoFull] = useState(false);
  const [index, setIndex] = useState<number>();

  const [add, setAdd] = useState(false);
  const [destaque, setDestaque] = useState(false);
  const [viewDestaque, setViewDestaque] = useState(false);
  const [lat, setLat] = useState<number>(0);
  const [long, setLong] = useState<number>(0);

  const [viewPhone, setViewPhone] = useState(false);

  const [loadingPdf, setLoadingPdf] = useState(false);
  const [loadingDownload, setLoadingDownload] = useState(false);

  const [openModal, setOpenModal] = useState(false);
  const [saibaMaisKey, setSaibaMaisKey] = useState('');

  const pin = L.icon({
    iconUrl: mapPin,
    iconSize: [50, 50],
    iconAnchor: [20, 40],
    popupAnchor: [0, -40],
  });

  const openOrCloseViewPhotos = () => {
    setViewAllPhotos(!viewAllPhotos);
  };

  const openOrCloseViewPhotosFull = () => {
    setViewPhotoFull(!viewPhotoFull);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const [dataProperty, setDataProperty] = useState<IPropertyDetailsCorrector>(
    {} as IPropertyDetailsCorrector,
  );
  const [dataRelacionados, setDataRelacionados] = useState<IBuildindCorretor[]>([]);
  const [dataMesmoEmpreendimento, setDataMesmoEmpreendimento] = useState<
    IBuildindCorretor[]
  >([]);
  const [person, setPerson] = useState<IPropsCorretor>({} as IPropsCorretor);
  const [isTime, setIsTime] = useState(false);

  const [screenWidth, setScreenWidth] = useState<number>(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const loadData = useCallback(() => {
    setLoading(true);
    const corretorId = id_corretor || user?.id_corretor;
    const request = corretorId
      ? api.get(`/portal/building/corret/${id}?id_corretor=${corretorId}`)
      : api.get(`portal/building/${id}`);

    request
      .then((res) => {
        const data = res.data[0];
        setDataProperty(data);
        setIsValidId(true);

        const favorited =
          data?.is_fixado == '1' || Number(data?.is_fixado) === 1;
        setAdd(favorited);
        setViewDestaque(favorited);
        setDestaque(data?.is_destaque_corretor === 1);
      })
      .catch((e) => {
        console.log(e?.response?.data?.err);
        setIsValidId(false);
      })
      .finally(() => setLoading(false));
  }, [api, id, id_corretor, user?.id_corretor]);

  const loadRelacionados = useCallback(() => {
    setLoadingRelation(true);

    const filtrarImovelPrincipal = (lista: any[]) =>
      lista.filter((imovel) => imovel.id !== dataProperty.id);

    if (!isValidId) {
      api
        .get(
          `/portal/building/list-building/0?seller&min_price&max_price&contract_type`,
        )
        .then((res) => {
          setDataRelacionados(filtrarImovelPrincipal(res.data));
        })
        .catch((e) => console.log(e))
        .finally(() => setLoadingRelation(false));
    } else {
      const relatedParams = {
        portal: 'hub',
        is_sale: dataProperty.is_venda,
        min_sale_price: dataProperty.valor_venda - dataProperty.valor_venda * 0.2,
        max_sale_price: dataProperty.valor_venda + dataProperty.valor_venda * 0.2,
        is_rent: dataProperty.is_aluguel,
        min_rent_price: dataProperty.valor_aluguel - dataProperty.valor_aluguel * 0.2,
        max_rent_price: dataProperty.valor_aluguel + dataProperty.valor_aluguel * 0.2,
        no_address: 1,
        id_corretor: user?.id_corretor ?? id_corretor ?? '',
      };

      api
        .get(`/portal/building/list-building/0`, { params: relatedParams })
        .then((res) => {
          setDataRelacionados(filtrarImovelPrincipal(res.data));
        })
        .catch((e) => console.log(e))
        .finally(() => setLoadingRelation(false));
    }
  }, [
    user,
    api,
    dataProperty.is_venda,
    dataProperty.valor_venda,
    dataProperty.is_aluguel,
    dataProperty.valor_aluguel,
    dataProperty.id,
    isValidId,
    id_corretor,
  ]);

  const loadMesmoEmpreendimento = useCallback(() => {
    setLoadingRelation(true);
    if (dataProperty.id_empreendimento) {
      api
        .get(
          '/portal/building/list-building/0?id_empreendimento=' +
            dataProperty.id_empreendimento,
        )
        .then((res) => {
          const id_imovel = dataProperty.id;
          const imoveisFiltrados = res.data.filter((item: any) => item.id !== id_imovel);
          setDataMesmoEmpreendimento(imoveisFiltrados);
        })
        .catch((e) => console.log(e))
        .finally(() => setLoadingRelation(false));
    }
  }, [dataProperty.id_empreendimento, api, dataProperty.id]);

  const loadPerson = useCallback(async () => {
    setLoadingPerson(true);
    if (id_corretor) {
      await api
        .get(`/portal/corretor/${id_corretor}`)
        .then((res) => {
          setPerson(res.data);
        })
        .catch((e) => console.log(e))
        .finally(() => setLoadingPerson(false));
    } else {
      setLoadingPerson(false);
    }
    if (user && !id_corretor) {
      await api
        .get(`/portal/corretor/${user.id_corretor}`)
        .then((res) => {
          setPerson(res.data);
        })
        .catch((e) => console.log(e))
        .finally(() => setLoadingPerson(false));
    } else {
      setLoadingPerson(false);
    }
  }, [api, id_corretor, user]);

  useEffect(() => {
    loadData();
    loadPerson();
    loadRelacionados();
    loadMesmoEmpreendimento();
  }, [id, loadData, loadPerson, loadRelacionados, loadMesmoEmpreendimento]);

  useEffect(() => {
    navigator.geolocation.watchPosition((position) => {
      const { latitude, longitude } = position.coords;
      setLat(latitude ? latitude : 0);
      setLong(longitude ? longitude : 0);
    });
  }, [id]);

  const backToTheHome = () => {
    navigate('/');
  };

  const handleVisita = useCallback(async () => {
    if (nomeCliente === '') {
      return toast.error('Digite o seu nome', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (contatoCliente1 === '') {
      return toast.error('Digite o número para contato', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (emailCliente === '') {
      return toast.error('Informe um e-mail para contato', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (!validator.isEmail(emailCliente)) {
      return toast.error('Digite um e-mail válido', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (dateReserve === undefined) {
      return toast.error('Selecione uma data para visita', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    if (isTime && horaReserva === '') {
      return toast.error('Selecione um horário para visita', {
        position: 'top-right',
        autoClose: 6000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: 'colored',
      });
    }

    setLoadingVisita(true);
    MySwal.fire({
      title: 'Aguarde',
      text: 'Estamos salvando as informações',
      icon: 'warning',
      didOpen: () => {
        MySwal.showLoading();
      },
    });

    await api
      .post('/schedule/add-visita', {
        id_corretor: id_corretor,
        dt_inicio:
          horaReserva !== '' ? dateFormat : new Date(dateReserve).toISOString(),
        descricao: 'Agendamento de visita',
        observacao: obs,
        id_imovel: dataProperty.id,
        cliente_descricao: nomeCliente,
        cliente_email: emailCliente,
        cliente_telefone1: contatoCliente1,
        cliente_telefone2: contatoCliente1,
      })
      .then(() => {
        setObs('');
        setNomeCliente('');
        setEmailCliente('');
        setContatoCliente1('');
        setHoraReserva('');
        setDateReserve(new Date());
        setIsTime(false);
        setViewPhone(true);
        MySwal.fire({
          icon: 'success',
          title: 'Sucesso!',
          text: 'O agendamento foi realizado. Em breve o corretor retornará o seu contato.',
          confirmButtonColor: '#0E2244',
        });
      })
      .catch((e) => {
        console.log(e);
        MySwal.fire({
          icon: 'error',
          title: 'Ops!',
          text: 'Não foi possível agendar sua visita.',
          confirmButtonColor: '#0E2244',
          footer: `${e.response.data.err}`,
        });
      })
      .finally(() => setLoadingVisita(false));
  }, [
    api,
    horaReserva,
    isTime,
    dataProperty,
    id_corretor,
    dateReserve,
    dateFormat,
    obs,
    nomeCliente,
    emailCliente,
    contatoCliente1,
  ]);

  const [scrollTop, setScrollTop] = useState<ScrollProps>({
    y: 0,
    lastY: 0,
  } as ScrollProps);
  const [show, setShow] = useState(false);

  const handleScroll = (event: React.UIEvent<HTMLDivElement>) => {
    const scrollTopValue = event.currentTarget.scrollTop;
    setScrollTop((prevState) => {
      return { y: scrollTopValue, lastY: prevState.y };
    });
  };

  const handleAddToProfile = useCallback(
    async (idBuilding: number) => {
      await api
        .post('/portal/seller/add-to-profile', {
          id_corretor: user?.id_corretor,
          id_imovel: idBuilding,
        })
        .then(() => {
          setAdd(true);
          setViewDestaque(true);
          setDataProperty((prev) => ({ ...prev, is_fixado: '1' }));
          return toast.success('Imóvel adicionado com sucesso ao seu perfil', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        })
        .catch((e) => {
          console.log(e);
          return toast.error('Não foi possível adicionar o imóvel ao seu perfil', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
    },
    [user, api],
  );

  const handleRemoveToProfile = useCallback(
    async (idBuilding: number) => {
      await api
        .post('/portal/seller/remove-from-profile', {
          id_corretor: user?.id_corretor,
          id_imovel: idBuilding,
        })
        .then(() => {
          setAdd(false);
          setViewDestaque(false);
          setDestaque(false);
          setDataProperty((prev) => ({ ...prev, is_fixado: null as any }));
          return toast.success('Imóvel retirado com sucesso do seu perfil', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        })
        .catch((e) => {
          console.log(e);
          return toast.error('Não foi possível retirar o imóvel do seu perfil', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
    },
    [user, api],
  );

  const handleAddDestaque = useCallback(
    async (idBuilding: number) => {
      await api
        .post('/portal/seller/highlight', {
          id_corretor: user?.id_corretor,
          id_imovel: idBuilding,
        })
        .then(() => {
          setDestaque(true);
          return toast.success('Imóvel adicionado com sucesso aos seus destaques', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        })
        .catch((e) => {
          console.log(e);
          toast.error('Não foi possível adicionar o imóvel aos destaques', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
          toast.error('Adicione o imóvel ao seu perfil primeiro', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
    },
    [user, api],
  );

  const handleRemoveDestaque = useCallback(
    async (idBuilding: number) => {
      await api
        .post('/portal/seller/remove-highlight', {
          id_corretor: user?.id_corretor,
          id_imovel: idBuilding,
        })
        .then(() => {
          setDestaque(false);
          return toast.success('Imóvel retirado com sucesso dos seus destaques', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        })
        .catch((e) => {
          console.log(e);
          return toast.error('Não foi possível retirar o imóvel dos destaques', {
            position: 'top-right',
            autoClose: 6000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: 'colored',
          });
        });
    },
    [user, api],
  );

  const copyToClipboard = async (text: string) => {
    console.log(text);
    if (!navigator.clipboard) {
      return;
    }
    return navigator.clipboard
      .writeText(text)
      .then(() => {
        toast.success('Link da página copiado com sucesso', {
          position: 'top-right',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      })
      .catch(() => {
        toast.error('Não foi possível copiar o link da página', {
          position: 'top-right',
          autoClose: 4000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
        console.log('Não foi possível copiar o link da página');
      });
  };

  const addToList = () => {
    addImovel(
      dataProperty.id_display
        ? dataProperty.id_display
        : dataProperty.id_imovel_kurole,
      dataProperty.id_imovel_kurole,
      dataProperty?.descricao ||
        `Imóvel excelente ${
          dataProperty?.endereco?.bairro
            ? `no bairro ${dataProperty?.endereco?.bairro}`
            : ''
        }${
          dataProperty?.endereco?.cidade
            ? ` em ${dataProperty?.endereco?.cidade}`
            : ''
        }`,
      dataProperty.arquivos.length ? dataProperty.arquivos[0].url : '',
    );
    toast.success('Imóvel adicionado a sua lista', {
      position: 'top-right',
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      draggable: true,
      progress: undefined,
    });
  };

  const alertRegister = useCallback(() => {
    MySwal.fire({
      icon: 'question',
      title: 'Gostou do imóvel?',
      text: 'Agende uma visita com o corretor, e logo após, o número ficará disponível.',
      confirmButtonColor: '#0E2244',
    });
  }, []);

  function handleOpenPhotoFull(indx: number) {
    setViewPhotoFull(true);
    setIndex(indx);
  }

  const getCardImovel = async () => {
    setLoadingPdf(true);
    await api
      .get(`/utils/get-imovel-card/${id}?portal=hub&id_corretor=${id_corretor || ''}`, {
        responseType: 'blob',
      })
      .then((response) => {
        setLoadingPdf(false);
        const blobCard = response.data;
        const url = window.URL.createObjectURL(blobCard);
        window.open(url, '_blank');
      })
      .catch((err) => {
        setLoadingPdf(false);
        console.log(err);
        toast.error('Ocorreu um erro ao gerar o PDF', {
          position: 'top-right',
          autoClose: 3000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          progress: undefined,
        });
      });
  };

  const handleGeneratePdf = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    if (loadingPdf) return;
    getCardImovel();
  };

  const downloadImages = async () => {
    try {
      setLoadingDownload(true);
      const response = await api.get(`/utils/get-anexos/${id}?portal=hub`, {
        responseType: 'blob',
      });
      const blob = new Blob([response.data], { type: 'application/zip' });
      const url = window.URL.createObjectURL(blob);
      const name = `galeria_${id}.zip`;
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', name);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      toast.error(
        'Ocorreu um erro ao fazer o download. Verifique seu login e tente novamente.',
      );
    } finally {
      setLoadingDownload(false);
    }
  };

  const handleDownload = (e: React.MouseEvent<HTMLButtonElement>): void => {
    e.preventDefault();
    if (loadingDownload) return;
    downloadImages();
  };

  useEffect(() => {
    let hora = '';
    if (dateReserve !== undefined) {
      hora = new Date(dateReserve).toISOString();
    }
    setDateFormat(`${hora.split('T')[0]}T${horaReserva}:00.000Z`);
  }, [horaReserva, dateReserve]);

  const saibaMaisData = useMemo(
    () => buildSaibaMaisFromCategories(dataProperty?.categorias),
    [dataProperty?.categorias],
  );

  const saibaMaisKeys = useMemo(() => Object.keys(saibaMaisData), [saibaMaisData]);

  useEffect(() => {
    if (saibaMaisKeys.length && !saibaMaisKeys.includes(saibaMaisKey)) {
      setSaibaMaisKey(saibaMaisKeys[0]);
    }
  }, [saibaMaisKeys, saibaMaisKey]);

  const idDisplay =
    dataProperty.id_display || dataProperty.id_imovel_kurole || '';

  const titleText =
    dataProperty?.descricao ||
    `Imóvel excelente ${
      dataProperty?.endereco?.bairro
        ? `no bairro ${dataProperty?.endereco?.bairro}`
        : ''
    }${
      dataProperty?.endereco?.cidade ? ` em ${dataProperty?.endereco?.cidade}` : ''
    }`;

  const locationLabel = [
    dataProperty?.endereco?.bairro,
    dataProperty?.endereco?.cidade,
  ]
    .filter(Boolean)
    .join(', ');

  const corretorShareId = id_corretor || user?.id_corretor;
  const shareUrl = corretorShareId
    ? `https://portal.hubnogueira.com.br/perfil/${
        person?.slug || corretorShareId
      }/imovel/${dataProperty.id_imovel_kurole}`
    : `https://portal.hubnogueira.com.br/imovel/${dataProperty.id_imovel_kurole}`;

  const mapCenter: [number, number] = dataProperty.endereco
    ? [
        Number(dataProperty.endereco.latitude),
        Number(dataProperty.endereco.longitude),
      ]
    : [0, 0];

  const relatedList =
    dataMesmoEmpreendimento?.length > 0
      ? dataMesmoEmpreendimento
      : dataRelacionados;

  const priceValue = dataProperty.is_venda
    ? dataProperty.valor_venda || 0
    : dataProperty.valor_aluguel || 0;

  const thumbOffset = dataProperty.url_video ? 0 : 1;

  const renderScheduleForm = (): ReactNode => (
    <ScheduleInner>
      {id_corretor ? (
        <div className="broker">
          <div onClick={() => navigate(`/perfil/${id_corretor}`)}>
            {person?.foto_perfil ? (
              <img alt="avatar" src={person?.foto_perfil} />
            ) : (
              <FaUserCircle className="avatar" size={48} />
            )}
          </div>
          <div>
            <h3 onClick={() => navigate(`/perfil/${id_corretor}`)}>{person?.nome}</h3>
            <p>{person?.email_contato}</p>
            {person?.telefone_01 ? (
              viewPhone ? (
                <p>
                  <MdLocalPhone /> {maskPhone(person?.telefone_01)}
                </p>
              ) : (
                <button
                  type="button"
                  onClick={alertRegister}
                  style={{
                    border: 'none',
                    background: 'transparent',
                    color: 'var(--color-primary)',
                    cursor: 'pointer',
                    padding: 0,
                    fontSize: '0.75rem',
                  }}
                >
                  <MdLocalPhone /> ...Ver número
                </button>
              )
            ) : null}
          </div>
        </div>
      ) : (
        <div className="broker">
          <img alt="logo-hub-nogueira" src="/images/logo-hub-capacete-white.png" />
          <div>
            <h2>Hub Nogueira</h2>
            <p>email@nogueira.com.br</p>
            <p>
              <MdLocalPhone /> (81)3019-3333
            </p>
          </div>
        </div>
      )}

      <h4>Gostou do imóvel? Agende uma visita!</h4>

      <div className="div-calendar">
        <Calendar
          className="calendar"
          minDate={new Date()}
          value={dateReserve}
          onChange={(v) => setDateReserve(v)}
          locale="pt-BR"
        />
      </div>

      <div className="text-and-check">
        <p>Definir horário para visita?</p>
        <input
          className="check"
          type="checkbox"
          disabled={loadingVisita}
          checked={isTime}
          onChange={(e) => setIsTime(e.target.checked)}
        />
      </div>

      {isTime && (
        <input
          type="time"
          value={horaReserva}
          disabled={loadingVisita}
          onChange={(e) => setHoraReserva(e.target.value)}
          placeholder="Hora da reserva"
        />
      )}

      <input
        type="text"
        disabled={loadingVisita}
        value={nomeCliente}
        onChange={(e) => setNomeCliente(e.target.value)}
        placeholder="Nome Completo"
      />
      <input
        type="text"
        disabled={loadingVisita}
        maxLength={11}
        value={maskPhone(contatoCliente1)}
        onChange={(e) => setContatoCliente1(e.target.value)}
        placeholder="DDD + Telefone"
      />
      <input
        type="email"
        disabled={loadingVisita}
        value={emailCliente}
        onChange={(e) => setEmailCliente(e.target.value)}
        placeholder="Digite seu e-mail"
      />
      <textarea
        value={obs}
        disabled={loadingVisita}
        onChange={(e) => setObs(e.target.value)}
        placeholder="Observação"
      />

      <Button
        label={loadingVisita ? 'Enviando' : 'Enviar'}
        width="100%"
        height="50px"
        color="#fff"
        bgcolor="#0F2445"
        onclick={handleVisita}
        mb="1rem"
        disable={loadingVisita}
      />

      <p className="privacy">
        Ao enviar, você concorda com nossa{' '}
        <a href="/politica-de-privacidade" target="_blank" rel="noopener noreferrer">
          Política de Privacidade
        </a>
        .
      </p>
    </ScheduleInner>
  );

  const isFavorited =
    dataProperty.is_fixado == '1' || Number(dataProperty.is_fixado) === 1;

  const actionButtons = (
    <>
      {user && isFavorited ? (
        <CircleBtn type="button" title="Adicionar à pasta" onClick={handleOpenModal}>
          <FiFolder />
        </CircleBtn>
      ) : null}

      {user && (isFavorited || viewDestaque) ? (
        dataProperty.is_destaque_corretor === 1 || destaque ? (
          <CircleBtn
            type="button"
            title="Remover destaque"
            onClick={() => handleRemoveDestaque(dataProperty.id)}
          >
            <FiStar style={{ fill: 'var(--color-primary)' }} />
          </CircleBtn>
        ) : (
          <CircleBtn
            type="button"
            title="Destacar imóvel"
            onClick={() => handleAddDestaque(dataProperty.id)}
          >
            <FiStar />
          </CircleBtn>
        )
      ) : null}

      {user && (isFavorited || add) ? (
        <CircleBtn
          type="button"
          title="Remover do perfil"
          onClick={() => handleRemoveToProfile(dataProperty.id)}
        >
          <FiMinusCircle />
        </CircleBtn>
      ) : user ? (
        <CircleBtn
          type="button"
          title="Adicionar ao perfil"
          onClick={() => handleAddToProfile(dataProperty.id)}
        >
          <FiPlusCircle />
        </CircleBtn>
      ) : null}
    </>
  );

  const gallery = (
    <>
      <GalleryDesktopOnly>
        <GalleryMain $hasVideo={Boolean(dataProperty.url_video && screenWidth >= 800)}>
          {dataProperty.url_video && screenWidth >= 800 ? (
            <div className="player-wrapper">
              <ReactPlayer
                url={dataProperty.url_video}
                controls={true}
                height="100%"
                width="100%"
                playing
                muted
                loop
                style={{ position: 'absolute', inset: 0 }}
              />
            </div>
          ) : (
            <img
              src={photoUrl(dataProperty?.arquivos?.[0]?.url)}
              alt="Imagem destaque do imóvel"
              onClick={() => {
                setViewPhotoFull(true);
                setIndex(0);
              }}
            />
          )}
          {dataProperty?.arquivos?.length > 0 && (
            <MorePhotosBtn type="button" onClick={openOrCloseViewPhotos}>
              <BiImages size={18} />
              Mais fotos
            </MorePhotosBtn>
          )}
        </GalleryMain>
        <GalleryThumbs>
          {[0, 1, 2, 3].map((offset) => {
            const fileIndex = thumbOffset + offset;
            const file = dataProperty?.arquivos?.[fileIndex];
            return (
              <GalleryThumb
                key={fileIndex}
                onClick={() => {
                  if (file) {
                    setViewPhotoFull(true);
                    setIndex(fileIndex);
                  }
                }}
              >
                <img
                  src={photoUrl(file?.url)}
                  alt={`Foto ${fileIndex + 1}`}
                  style={{ opacity: file ? 1 : 0.4 }}
                />
              </GalleryThumb>
            );
          })}
        </GalleryThumbs>
      </GalleryDesktopOnly>

      <GalleryMobile>
        <Carosel2
          autoPlay
          interval={4000}
          showThumbs={false}
          infiniteLoop
          showStatus={false}
          onClickItem={(idx: number) => handleOpenPhotoFull(idx)}
        >
          {dataProperty.arquivos?.map((arquive) => (
            <img
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = PLACEHOLDER_IMG;
              }}
              key={arquive.index}
              src={arquive.url}
              alt="imagem do imóvel"
            />
          ))}
        </Carosel2>
        {dataProperty?.arquivos?.length > 0 && (
          <div style={{ marginTop: '0.75rem', display: 'flex', justifyContent: 'flex-end' }}>
            <MorePhotosBtn
              type="button"
              onClick={openOrCloseViewPhotos}
              style={{ position: 'static' }}
            >
              <BiImages size={18} />
              Mais fotos
            </MorePhotosBtn>
          </div>
        )}
      </GalleryMobile>

      {viewAllPhotos &&
        createPortal(
          <ShowAllPhotos
            isOpen={viewAllPhotos}
            files={dataProperty.arquivos}
            onClose={openOrCloseViewPhotos}
          />,
          document.body,
        )}
      {viewPhotoFull &&
        createPortal(
          <ShowPhotoLargue
            isOpen={viewPhotoFull}
            files={dataProperty.arquivos}
            onClose={openOrCloseViewPhotosFull}
            index={index}
          />,
          document.body,
        )}
    </>
  );

  const shareToolbar = (
    <>
      <ShareCircleBtn
        type="button"
        title="Adicionar à lista de compartilhamentos"
        onClick={() => addToList()}
      >
        <FiShare2 />
      </ShareCircleBtn>
      <ShareCircleBtn
        type="button"
        title="Copiar link para compartilhar"
        onClick={() => copyToClipboard(shareUrl)}
      >
        <FiLink />
      </ShareCircleBtn>
      <ShareCircleLink
        href={`https://api.whatsapp.com/send?text=${encodeURIComponent(
          `Vi este imóvel no Portal Hub Nogueira e acho que você pode gostar!\n${shareUrl}`,
        )}`}
        target="_blank"
        rel="noreferrer"
        title="Compartilhar no WhatsApp"
      >
        <MdWhatsapp />
      </ShareCircleLink>
      {user && (
        <DownloadBtn
          type="button"
          title="Baixar fotos"
          onClick={handleDownload}
          disabled={loadingDownload}
        >
          {loadingDownload ? (
            <>
              <Spin
                style={{ color: '#fff' }}
                size="small"
                indicator={<LoadingOutlined spin />}
              />
              <span>Baixando...</span>
            </>
          ) : (
            <>
              <FiDownload />
              <span>Baixar fotos</span>
            </>
          )}
        </DownloadBtn>
      )}
    </>
  );

  const description = (
    <>
      {dataProperty.is_condominio === 1 && (
        <MetaRow>
          {dataProperty.ap_bloco ? <p>Bloco: {dataProperty.ap_bloco}</p> : null}
          {dataProperty.ap_numero ? <p>Unidade: {dataProperty.ap_numero}</p> : null}
        </MetaRow>
      )}
      <BodyText>{dataProperty.sobre}</BodyText>
      {user && (
        <PdfLinkBtn type="button" onClick={handleGeneratePdf} disabled={loadingPdf}>
          {!loadingPdf && <IoDocumentText size={18} />}
          {loadingPdf && (
            <Spin style={{ color: '#0E2244' }} indicator={<LoadingOutlined spin />} />
          )}
          {loadingPdf
            ? 'Gerando seu cartão de informações...'
            : 'Gerar Cartão de Informações'}
        </PdfLinkBtn>
      )}
    </>
  );

  const overview = (
    <OverviewGrid>
      {dataProperty?.area_construida ? (
        <OverviewItem>
          <OverviewIcon>
            <FaChartArea />
          </OverviewIcon>
          <OverviewText>
            <p>ÁREA CONSTRUÍDA</p>
            <p>{formatArea(dataProperty.area_construida)}</p>
          </OverviewText>
        </OverviewItem>
      ) : null}
      {dataProperty?.area_total ? (
        <OverviewItem>
          <OverviewIcon>
            <BiArea />
          </OverviewIcon>
          <OverviewText>
            <p>ÁREA TOTAL</p>
            <p>{formatArea(dataProperty.area_total)}</p>
          </OverviewText>
        </OverviewItem>
      ) : null}
      <OverviewItem>
        <OverviewIcon>
          <MdMeetingRoom />
        </OverviewIcon>
        <OverviewText>
          <p>QUARTOS</p>
          <p>{dataProperty?.qtd_quartos ?? 0}</p>
        </OverviewText>
      </OverviewItem>
      <OverviewItem>
        <OverviewIcon>
          <MdOutlineBathroom />
        </OverviewIcon>
        <OverviewText>
          <p>BANHEIROS</p>
          <p>{dataProperty?.qtd_banheiros ?? 0}</p>
        </OverviewText>
      </OverviewItem>
      <OverviewItem>
        <OverviewIcon>
          <FaBath />
        </OverviewIcon>
        <OverviewText>
          <p>SUÍTES</p>
          <p>{dataProperty?.qtd_suites ?? 0}</p>
        </OverviewText>
      </OverviewItem>
      <OverviewItem>
        <OverviewIcon>
          <FaCar />
        </OverviewIcon>
        <OverviewText>
          <p>VAGAS DE GARAGEM</p>
          <p>{dataProperty?.qtd_vagas ?? 0}</p>
        </OverviewText>
      </OverviewItem>
      {dataProperty?.ano_construcao && dataProperty?.ano_construcao !== 0 ? (
        <OverviewItem>
          <OverviewIcon>
            <FaRegCalendarAlt />
          </OverviewIcon>
          <OverviewText>
            <p>ANO DE CONCLUSÃO</p>
            <p>{dataProperty.ano_construcao}</p>
          </OverviewText>
        </OverviewItem>
      ) : null}
    </OverviewGrid>
  );

  const saibaMais = saibaMaisKeys.length ? (
    <SaibaMaisCard>
      <SaibaMaisTabs>
        {saibaMaisKeys.map((key) => (
          <SaibaMaisTab
            key={key}
            type="button"
            $active={saibaMaisKey === key}
            onClick={() => setSaibaMaisKey(key)}
          >
            {key}
          </SaibaMaisTab>
        ))}
      </SaibaMaisTabs>
      <SaibaMaisItems>
        {(saibaMaisData[saibaMaisKey] || []).map((item, index) => (
          <SaibaMaisItem key={`${item}-${index}`}>
            <p>{item}</p>
          </SaibaMaisItem>
        ))}
      </SaibaMaisItems>
    </SaibaMaisCard>
  ) : null;

  const locationInfo = (
    <LocationLines>
      {user && (
        <LocationLine>
          <MdLocationPin />
          <p>
            {dataProperty?.endereco?.logradouro}, {dataProperty?.endereco?.bairro},{' '}
            {dataProperty?.endereco?.cidade}
          </p>
        </LocationLine>
      )}
      {user && (
        <LocationLine>
          <p>
            <b>CEP: </b>
            {dataProperty?.endereco?.cep}
          </p>
        </LocationLine>
      )}
    </LocationLines>
  );

  const mapSlot = (
    <MapContainer
      center={mapCenter}
      zoom={17}
      style={{ width: '100%', height: '100%' }}
      scrollWheelZoom={false}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.carto.com/">CARTO</a>'
        url="https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png?key=cb1_27id_1_0ce26f1e1fbfb85845fb05de"
      />
      {user ? (
        <Marker position={mapCenter} icon={pin} />
      ) : (
        <Circle
          center={mapCenter}
          radius={150}
          pathOptions={{ color: '#123b81', fillColor: '#0e2244', fillOpacity: 0.2 }}
        />
      )}
    </MapContainer>
  );

  const priceBlock = (
    <PriceBlock>
      <p className="from">
        {dataProperty.is_aluguel && !dataProperty.is_venda
          ? 'Aluguel a partir de:'
          : 'A partir de:'}
      </p>
      <div className="price-row">
        <h4 className="price">
          {new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL',
          }).format(priceValue)}
        </h4>
        <p>*</p>
      </div>
      <p className="note">* Sujeito a disponibilidade</p>
    </PriceBlock>
  );

  const relatedSection =
    relatedList && relatedList.length > 0 ? (
      <SectionRails
        variant="standard"
        title="Imóveis parecidos"
        subtitle="Empreendimentos em comum"
      >
        {relatedList.map((item) => (
          <PropertyCardCarousel
            key={item.id}
            id={item.id}
            idDisplay={item.id_display}
            bairro={item.bairro}
            cidade={item.cidade}
            descricao={item.descricao}
            valorVenda={item.valor_venda}
            apBloco={item.ap_bloco}
            apNumero={item.ap_numero}
            imageUrl={item.arquivos?.[0]?.url}
          />
        ))}
      </SectionRails>
    ) : null;

  const handleOuvidoria = (motivo?: string) => {
    navigate('/ouvidoria', { state: { motivo } });
  };

  return (
    <Mainframe>
      <Container onScroll={handleScroll} show={show}>
        <Header
          show={show}
          setShow={setShow}
          scroll={scrollTop}
          search={search}
          setSearch={setSearch}
        />
        {loading || loadingRelation || loadingPerson ? (
          <LoadSpinner2 />
        ) : (
          <>
            {isValidId ? (
              <PropertyDetailLayout
                variant="imovel"
                titleIdDisplay={idDisplay}
                titleText={titleText}
                locationLabel={locationLabel}
                idDisplayForOuvidoria={idDisplay}
                actionButtons={actionButtons}
                gallery={gallery}
                shareToolbar={shareToolbar}
                description={description}
                overview={overview}
                saibaMais={saibaMais}
                locationInfo={locationInfo}
                mapSlot={mapSlot}
                priceBlock={priceBlock}
                scheduleDesktop={renderScheduleForm()}
                scheduleMobile={renderScheduleForm()}
                relatedSection={relatedSection}
                onOuvidoria={handleOuvidoria}
              />
            ) : (
              <div>
                <NotFoundContent>
                  <button type="button" onClick={backToTheHome}>
                    <IoChevronBackOutline className="icon" />
                    Voltar
                  </button>
                </NotFoundContent>

                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    flexDirection: 'column',
                    marginBottom: '15vh',
                    marginTop: '15vh',
                    padding: '0 1rem',
                    textAlign: 'center',
                  }}
                >
                  <h1>O imóvel que você busca não está disponível no momento.</h1>
                  <SadAnimation />
                  <p style={{ paddingTop: '20px' }}>
                    Mas não se preocupe, temos várias opções interessantes para você!
                  </p>
                </div>

                {dataRelacionados?.length > 0 && (
                  <div style={{ padding: '0 1rem 3rem' }}>
                    <SectionRails
                      variant="standard"
                      title="Continue sua busca com imóveis similares abaixo"
                    >
                      {dataRelacionados.map((item) => (
                        <PropertyCardCarousel
                          key={item.id}
                          id={item.id}
                          idDisplay={item.id_display}
                          bairro={item.bairro}
                          cidade={item.cidade}
                          descricao={item.descricao}
                          valorVenda={item.valor_venda}
                          apBloco={item.ap_bloco}
                          apNumero={item.ap_numero}
                          imageUrl={item.arquivos?.[0]?.url}
                        />
                      ))}
                    </SectionRails>
                  </div>
                )}
              </div>
            )}

            <ModalAddToFolder
              onSuccess={loadData}
              handleCloseModal={handleCloseModal}
              openModal={openModal}
              idImovel={dataProperty.id}
            />

            <GoToTop />
            <Footer />
          </>
        )}
      </Container>
    </Mainframe>
  );
}
